export class Job {
    public name!: string
    public slug!: string
    public title!: string
    public nnid!: string
    public description!: string
    public details!: string
    public keywords!: string
    public photo01!: string
    public locations: string[] = []
    public timeType!: string
    public type!: string
    constructor() { }

}
